import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { Logo } from './Logo';
import { clinic, patientLinks } from '../../data/clinic';
const careLinks = [{
  label: 'Pijnklachten',
  to: '/pijnbehandelingen'
}, {
  label: 'Behandelingen',
  to: '/behandelingen'
}, {
  label: 'Voor verwijzers',
  to: '/verwijzers'
}, {
  label: 'Over ons',
  to: '/over-ons'
}, {
  label: 'Ervaringen',
  to: '/ervaringen'
}, {
  label: 'Vacatures',
  to: '/vacatures'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function Footer() {
  return <footer className="bg-ink text-white" data-id="element-154" data-mp="3n3k9u6dm4nqe">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 lg:grid-cols-12 lg:px-8 lg:py-20" data-id="element-155" data-mp="3n4lun2kfkolb">
        <div className="lg:col-span-4" data-id="element-156" data-mp="3j30g7cs90290">
          <div className="inline-flex rounded-2xl bg-white px-4 py-3" data-id="element-157" data-mp="3j05sncdxu1bd">
            <Logo className="h-10" data-id="element-158" data-mp="3e2coeow73hdq" />
          </div>
          <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-white/70" data-id="element-159" data-mp="3942uehm7imtp">
            Onafhankelijk specialistisch pijnbehandelcentrum in Velsen-Noord. Behandeling door anesthesioloog-pijnspecialisten
            en (pijn)verpleegkundigen.
          </p>
          <ul className="mt-6 flex gap-5" data-id="element-160" data-mp="2p54kyh2im169">
            {clinic.socials.map(s => <li key={s.label} data-id="element-161" data-mp="2bdzqruhx213b">
                <a href={s.href} target="_blank" rel="noreferrer" className="text-sm font-medium text-cyan hover:text-white" data-id="element-162" data-mp="2gbj3gpyyu5t5">
                  {s.label}
                </a>
              </li>)}
          </ul>
        </div>

        <nav aria-label="Zorg" className="lg:col-span-2" data-id="element-163" data-mp="382z07cu8l8x3">
          <h2 className="font-display text-base font-semibold" data-id="element-164" data-mp="380crvaziupdt">Zorg</h2>
          <ul className="mt-4 space-y-2.5" data-id="element-165" data-mp="2u2o7035gfi8r">
            {careLinks.map(item => <li key={item.to} data-id="element-166" data-mp="2z0pncgbhx3gj">
                <Link to={item.to} className="text-[15px] text-white/70 hover:text-white" data-id="element-167" data-mp="2z3u0i36xv9jc">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <nav aria-label="Voor patiënten" className="lg:col-span-3" data-id="element-168" data-mp="1nkhlyi7svy6g">
          <h2 className="font-display text-base font-semibold" data-id="element-169" data-mp="13k7s010yefir">Voor patiënten</h2>
          <ul className="mt-4 space-y-2.5" data-id="element-170" data-mp="zkfinm3qk5cc">
            {patientLinks.map(item => <li key={item.label} data-id="element-171" data-mp="ure0944blno0">
                {item.external ? <a href={item.to} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-[15px] text-white/70 hover:text-white" data-id="element-172" data-mp="ptkto9z3urn7">
                    {item.label}
                    <ArrowUpRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-173" data-mp="fv54wdnjvugv" />
                  </a> : <Link to={item.to} className="text-[15px] text-white/70 hover:text-white" data-id="element-174" data-mp="bss0bskji2lo">
                    {item.label}
                  </Link>}
              </li>)}
          </ul>
        </nav>

        <div className="lg:col-span-3" data-id="element-175" data-mp="2672odytb8sqe">
          <h2 className="font-display text-base font-semibold" data-id="element-176" data-mp="218hxwr3v1nf5">Bezoek & contact</h2>
          <address className="mt-4 space-y-3 text-[15px] not-italic text-white/70" data-id="element-177" data-mp="216nclbooftaj">
            <p data-id="element-178" data-mp="28rqypvyawdsl">
              {clinic.street}
              <br data-id="element-179" data-mp="2dqk9vhq47spl" />
              {clinic.postalCode} {clinic.city}
            </p>
            <p data-id="element-180" data-mp="2ihu28q31ta56">
              <a href={clinic.phoneHref} className="font-semibold text-cyan hover:text-white" data-id="element-181" data-mp="2ihaid3tu8boi">
                {clinic.phone}
              </a>
              <br data-id="element-182" data-mp="2ng3vgv57q0o5" />
              <a href={`mailto:${clinic.email}`} className="break-all hover:text-white" data-id="element-183" data-mp="2niq2mto6ye5u">
                {clinic.email}
              </a>
            </p>
            <p data-id="element-184" data-mp="1utaq1zgvod7t">{clinic.hours}</p>
          </address>
        </div>
      </div>
      <div className="border-t border-white/10" data-id="element-185" data-mp="1zqt3o35ubgm5">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-5 py-6 text-sm text-white/60 sm:flex-row sm:justify-between lg:px-8" data-id="element-186" data-mp="1zq17aq4f5eut">
          <p data-id="element-187" data-mp="3b6rh0j81wot6">© 2026 Excellent Care Clinics</p>
          <div className="flex gap-6" data-id="element-188" data-mp="3b5pw7n18gny9">
            <Link to="/klachteninformatie" className="hover:text-white" data-id="element-189" data-mp="3b8u7t5h12lyy">
              Klachteninformatie
            </Link>
            <a href={clinic.termsPdf} target="_blank" rel="noreferrer" className="hover:text-white" data-id="element-190" data-mp="3dqe2n933rov6">
              Algemene voorwaarden
            </a>
          </div>
        </div>
      </div>
    </footer>;
}